// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tags {
    position: relative;
    padding: 6px 0 0 6px;
    margin: 10px 0 10px 0;
    border: 1px solid #d1d1d1;
    border-radius: 1px;
    background-color: #ffffff;

    /* shared font styles */
    font-size: 1em;
    line-height: 1.2;

    /* clicking anywhere will focus the input */
    cursor: text;
}

.react-tags.is-focused {
    border-color: #b1b1b1;
}

.react-tags__selected {
    display: inline;
}

.react-tags__selected-tag {
    display: inline-block;
    box-sizing: border-box;
    margin: 0 6px 6px 0;
    padding: 6px 8px;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    background: #f1f1f1;

    /* match the font styles */
    font-size: inherit;
    line-height: inherit;
}

.react-tags__selected-tag:after {
    content: '\\2715';
    color: #aaa;
    margin-left: 8px;
}

.react-tags__selected-tag:hover,
.react-tags__selected-tag:focus {
    border-color: #b1b1b1;
}

.react-tags__search {
    display: inline-block;

    /* match tag layout */
    padding: 7px 2px;
    margin-bottom: 6px;

    /* prevent autoresize overflowing the container */
    max-width: 100%;
}

@media screen and (min-width: 30em) {
    .react-tags__search {
        /* this will become the offsetParent for suggestions */
        position: relative;
    }
}

.react-tags__search-input {
    /* prevent autoresize overflowing the container */
    max-width: 100%;

    /* remove styles and layout from this element */
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;

    /* match the font styles */
    font-size: inherit;
    line-height: inherit;
}

.react-tags__search-input::-ms-clear {
    display: none;
}

.react-tags__suggestions {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 10;
}

@media screen and (min-width: 30em) {
    .react-tags__suggestions {
        width: 240px;
    }
}

.react-tags__suggestions ul {
    margin: 4px -1px;
    padding: 0;
    list-style: none;
    background: white;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.react-tags__suggestions li {
    border-bottom: 1px solid #ddd;
    padding: 6px 8px;
}

.react-tags__suggestions li mark {
    text-decoration: underline;
    background: none;
    font-weight: 600;
}

.react-tags__suggestions li:hover {
    cursor: pointer;
    background: #eee;
}

.react-tags__suggestions li.is-active {
    background: #b7cfe0;
}

.react-tags__suggestions li.is-disabled {
    opacity: 0.5;
    cursor: auto;
}
`, "",{"version":3,"sources":["webpack://./css/reacttags.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;;IAEzB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;;IAEhB,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;;IAEnB,0BAA0B;IAC1B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;;IAErB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;;IAElB,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI;QACI,sDAAsD;QACtD,kBAAkB;IACtB;AACJ;;AAEA;IACI,iDAAiD;IACjD,eAAe;;IAEf,+CAA+C;IAC/C,SAAS;IACT,UAAU;IACV,SAAS;IACT,aAAa;;IAEb,0BAA0B;IAC1B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".react-tags {\n    position: relative;\n    padding: 6px 0 0 6px;\n    margin: 10px 0 10px 0;\n    border: 1px solid #d1d1d1;\n    border-radius: 1px;\n    background-color: #ffffff;\n\n    /* shared font styles */\n    font-size: 1em;\n    line-height: 1.2;\n\n    /* clicking anywhere will focus the input */\n    cursor: text;\n}\n\n.react-tags.is-focused {\n    border-color: #b1b1b1;\n}\n\n.react-tags__selected {\n    display: inline;\n}\n\n.react-tags__selected-tag {\n    display: inline-block;\n    box-sizing: border-box;\n    margin: 0 6px 6px 0;\n    padding: 6px 8px;\n    border: 1px solid #d1d1d1;\n    border-radius: 2px;\n    background: #f1f1f1;\n\n    /* match the font styles */\n    font-size: inherit;\n    line-height: inherit;\n}\n\n.react-tags__selected-tag:after {\n    content: '\\2715';\n    color: #aaa;\n    margin-left: 8px;\n}\n\n.react-tags__selected-tag:hover,\n.react-tags__selected-tag:focus {\n    border-color: #b1b1b1;\n}\n\n.react-tags__search {\n    display: inline-block;\n\n    /* match tag layout */\n    padding: 7px 2px;\n    margin-bottom: 6px;\n\n    /* prevent autoresize overflowing the container */\n    max-width: 100%;\n}\n\n@media screen and (min-width: 30em) {\n    .react-tags__search {\n        /* this will become the offsetParent for suggestions */\n        position: relative;\n    }\n}\n\n.react-tags__search-input {\n    /* prevent autoresize overflowing the container */\n    max-width: 100%;\n\n    /* remove styles and layout from this element */\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: none;\n\n    /* match the font styles */\n    font-size: inherit;\n    line-height: inherit;\n}\n\n.react-tags__search-input::-ms-clear {\n    display: none;\n}\n\n.react-tags__suggestions {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    z-index: 10;\n}\n\n@media screen and (min-width: 30em) {\n    .react-tags__suggestions {\n        width: 240px;\n    }\n}\n\n.react-tags__suggestions ul {\n    margin: 4px -1px;\n    padding: 0;\n    list-style: none;\n    background: white;\n    border: 1px solid #d1d1d1;\n    border-radius: 2px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.react-tags__suggestions li {\n    border-bottom: 1px solid #ddd;\n    padding: 6px 8px;\n}\n\n.react-tags__suggestions li mark {\n    text-decoration: underline;\n    background: none;\n    font-weight: 600;\n}\n\n.react-tags__suggestions li:hover {\n    cursor: pointer;\n    background: #eee;\n}\n\n.react-tags__suggestions li.is-active {\n    background: #b7cfe0;\n}\n\n.react-tags__suggestions li.is-disabled {\n    opacity: 0.5;\n    cursor: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
